import React, { Component } from 'react';
import { connect } from 'react-redux';

import ErrorCard from 'presentational/ErrorCard';
import FormControlCard from 'presentational/FormControlCard';
import StandardSettingsPage from 'presentational/StandardSettingsPage';
import Loading from 'presentational/Loading';
import Footer from 'presentational/Footer';
import Person from '@material-ui/icons/Person';
import PersonIcon from '@material-ui/icons/PersonOutline';
import PasswordIcon from '@material-ui/icons/Security';
import ContactPhone from '@material-ui/icons/ContactPhone';
import EmailIcon from '@material-ui/icons/Email';
import RestoreIcon from '@material-ui/icons/Restore';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import { getCoreHttp, putCoreHttp, deleteCoreHttp } from 'actions/httpRequest';

class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            form: {},
            submitError: null,
            unique_username: false,
            userNameEdited: false
        };
        this.mfaSettingsRequested = false;
    }
  
    componentDidMount() {

      if (this.props.data){
        let form = this.props.data;

        if(!this.props.newUser){
          form.dynamicagentid = this.getDynamicAgentId(this.props);
        }

        this.setState({ form });

        // Load MFA settings for existing users
        if (!this.props.newUser && form.userName && !this.mfaSettingsRequested) {
          this.mfaSettingsRequested = true;
          // Small delay to ensure component is fully mounted
          setTimeout(() => {
            this.getMFASettings();
          }, 100);
        }
      }

      let { newUser } = this.props;
      let { unique_username } = this.state;

      //* If we are updating an existing user, let's not let them update the username.
      if (!newUser && unique_username) {
        this.setState({ unique_username: false })
      }

    }

    componentDidUpdate () {
      let { newUser } = this.props;
      let { userNameEdited, unique_username } = this.state;

      //* If we Switched to a new user form, lets make sure we make the username match the 
      //* email unless they have made changes to the username.
      if (!userNameEdited && newUser && unique_username) {
        this.setState({ unique_username: false })
      }

      // Handle MFA settings data when it arrives
      if (this.props.mfaSettings && this.props.mfaSettings !== this.previousMfaSettings) {
        this.previousMfaSettings = this.props.mfaSettings;

        // Handle different possible data structures
        let mfaData = this.props.mfaSettings;

        // If data is nested in a 'data' property
        if (mfaData.data) {
          mfaData = mfaData.data;
        }

        // If data is an array, take the first object
        if (Array.isArray(mfaData)) {
          mfaData = mfaData[0] || {};
        }

        // Merge MFA settings into form state and force re-render
        this.setState(prevState => {
          const updatedForm = {
            ...prevState.form,
            mfa_enabled: mfaData.mfa_enabled || '0',
            mfa_enforced: mfaData.mfa_enforced || '0',
          };

          return { form: updatedForm };
        });
      }
      
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.data) {
            let form = nextProps.data;
            if (form.groups) {
              if (form.groups[0] == "cloudadmin") {
                form.groups = "Administrator"
              } else if (form.groups[0] == "cloudusers") {
                form.groups = "Cloud User"
              } else if (form.groups == "partneradmin" && (app.token.get("role") === "superduperadmin" || app.token.get("role") === "partneradmin")) {
                form.groups = "Partner Admin"
              }
            }
            if(!nextProps.newUser){
              form.dynamicagentid = this.getDynamicAgentId(nextProps);
            }

            // Check if user has changed (different userName)
            const currentUserName = this.props.data?.userName;
            const nextUserName = nextProps.data?.userName;
            const userChanged = currentUserName !== nextUserName;

            // If user changed, reset MFA state and flag
            if (userChanged) {
              this.mfaSettingsRequested = false;
              this.previousMfaSettings = null;

              // Clear MFA data from form to avoid showing stale data
              form.mfa_enabled = undefined;
              form.mfa_enforced = undefined;
            }

            this.setState({ form });

            // Load MFA settings when data becomes available or when user changes
            if (!nextProps.newUser && form.userName && (!this.mfaSettingsRequested || userChanged)) {
              this.mfaSettingsRequested = true;
              setTimeout(() => {
                this.getMFASettings();
              }, 100);
            }
        }
    }

    getMFASettings() {

      const { userName } = this.state.form || {};
      if (!userName) {
          console.warn('[loginmanagement.settings.getMFASettings] No username found; cannot get MFA settings.');
          return;
      }

      const reqData = {
        reqAction: 'mfa',
        reqObject: userName,
      };

      // Use 'mfa' storeKey to match userSettings reducer expectation
      this.props.getCoreHttp(reqData, 'mfa');
    }

    // Helper method for manual testing/refresh
    refreshMFASettings() {
      console.log("[[INFO] Manually refreshing MFA settings");
      this.getMFASettings();
    }

    getDynamicAgentId(props){

      console.log("[[INFO] loginmanagement.settings.getdynamicagentid] Getting Dynamic Agent ID");

      var dynamicagentid = "";

      if (props.configurations && props.configurations.dynamicagents) {
        props.configurations.dynamicagents.map(agent => {
          if (agent.username == props.data.userName) {
            if (dynamicagentid) {
              dynamicagentid += ", " + agent.agent_id;
            } else {
              dynamicagentid += agent.agent_id;
            }
          }
        })
      }

      return dynamicagentid;
    }

    resetMFAEnrollment() {
        // Trigger API call to reset the user's MFA enrollment.
        const { userName } = this.state.form || {};
        if (!userName) {
            console.warn('[loginmanagement.settings.resetMFAEnrollment] No username found; cannot reset MFA.');
            return;
        }

        const reqData = {
          reqAction: 'resetmfa',
          reqObject: userName,
        };

        this.props.deleteCoreHttp(reqData, 'reset_mfa');
    }

    submitForm(field, data) {

        // Handle MFA toggle conversion from boolean to string
        if (field === 'mfa_enabled') {
            data = data ? '1' : '0';
        }

        if (this.state.form[field] == data) {
            console.log('No update');
            return;
        }

        const { form, userNameEdited, unique_username } = this.state;
        const { newUser } = this.props;
        const rollbackForm = Object.assign({}, form);

        // Lets validate our field
        const error = this.validateField(field, data);
        if (error) {
            this.setState({
                errors: { [field]: error },
                form: rollbackForm,
            });
            return;
        }

        if (field == 'mail' && !userNameEdited && newUser || field == 'mail' && !unique_username && newUser) {
          form['userName'] = data;
        }

        // If user changes userName so it no longer matches email set flag so changing email no longer updates userName
        if (field == 'userName') {
          this.setState({ 
            unique_username: true,
            userNameEdited: true
          });
        }

        // If no error, lets set the data
        // on the form and set it to state without errors
        form[field] = data;
        this.setState({
            form,
            errors: { [field]: '' },
        });
    }

    validateField(field, data) {
        // We want to make sure our wait
        // times are actually numbers
        // and greater than 0
        switch (field) {
        default:
            return null;
        }
    }

    submitFullForm(cancel){
      if(cancel){
        this.props.onCancel();
      } else{
        // Save MFA settings if they exist in the form
        if (this.state.form.mfa_enabled !== undefined && !this.props.newUser) {
          this.saveMFASettings();
        }

        this.props.submitForm(this.state.form);
      }
    }

    // Helper method to save MFA settings
    saveMFASettings() {
      console.log("[[INFO] Saving MFA settings with form submission");

      const { userName } = this.state.form || {};
      if (!userName) {
          console.warn('[loginmanagement.settings.saveMFASettings] No username found; cannot save MFA settings.');
          return;
      }

      const reqBody = {
        mfa_enabled: this.state.form.mfa_enabled || '0',
        username: userName,
      };

      const reqData = {
        reqAction: 'mfasettings',
        reqBody,
      };

      console.log("[[INFO] Saving MFA settings:", reqBody);
      this.props.putCoreHttp(reqData, 'mfa');
    }

    render() {

        if (this.props.newUserBypass || !this.props.data || !this.state.form) {
            return (
              <StandardSettingsPage>
                <Loading />
              </StandardSettingsPage>
            );
        }

        const style = {
            submit: {
                marginTop: 20
            }
        }

        const twinForm = {
            firstField: this.props.data.firstName || '',
            secondField: this.props.data.lastName || ''
        }
        const passTitle = this.props.newUser ? "Password" : "Password Reset"
        

        let userRoles = ["Administrator", "Cloud User"];
        let userRoleValues = ["cloudadmin", "cloudusers"];
        
        if (app.token.get("role") === "superduperadmin" || app.token.get("role") === "partneradmin"){
          userRoles.unshift("Partner Admin");
          userRoleValues.unshift("partneradmin");
        }
        userRoleValues.forEach(role => {
          if (this.state.form.groups && this.state.form.groups !== role && !this.state.form.groups.includes(role) && !userRoleValues.includes(this.state.form.groups) && !userRoleValues.includes(this.state.form.groups[0]) && !userRoles.includes(this.state.form.groups)) {
            userRoles.push(this.state.form.groups)
          }
        });

        return (
          <div style={{
            display: 'flex',
            flex: 1,
            height: '100%',
            background: '#EFEFEF',
            flexDirection: 'column',
            alignItems: 'center',
            paddingBottom: '50px',
            overflow: 'auto',
          }}>
          <StandardSettingsPage>
            {this.state.submitError ?
              <ErrorCard data={this.state.submitError} />
              : null
            }
            <FormControlCard
              form={this.state.form}
              field="twinForm"
              twinForm={twinForm}
              fieldOne="firstName"
              fieldTwo="lastName"
              formControl="TwoTextInput"
              title="Name"
              firstFieldTitle="First Name"
              secondFieldTitle="Last Name"
              subtitle=""
              icon={<PersonIcon />}
              submitForm={(field, data) => this.submitForm(field, data)}
            />
            {!this.state.form.New &&
            <FormControlCard
              form={this.state.form}
              field="mail"
              formControl="TextInput"
              title="Email"
              subtitle=""
              icon={<EmailIcon />}
              submitForm={(field, data) => this.submitForm(field, data)}
            />
            }
            <FormControlCard
              disabled={this.props.disableNameChange}
              form={this.state.form}
              field="userName"
              value = {this.state.form.userName}
              formControl="TextInput"
              title="Username"
              icon={<Person />}
              subtitle="Usernames must be your email and at least 6 characters long"
              submitForm={(field, data) => this.submitForm(field, data)}
            />
            <FormControlCard
              form={this.state.form}
              field="groups"
              formControl="SelectInput"
              title="User Group"
              subtitle="User group associated with the user"
              icon={<PersonIcon />}
              submitForm={(field, data) => this.submitForm(field, data)}
              options={userRoles}
            />
            <FormControlCard
              form={this.state.form}
              field="extension"
              formControl="TextInput"
              title="Primary Extension"
              subtitle=""
              icon={<ContactPhone />}
              submitForm={(field, data) => this.submitForm(field, data)}
            />
            {this.state.form.dynamicagentid && 
            <FormControlCard
              disabled={true}
              form={this.state.form}
              field="dynamicagentid"
              formControl="TextInput"
              title="Agent ID"
              subtitle=""
              icon={<PersonIcon />}
            />
            }
            <FormControlCard
              form={this.state.form}
              field="pass"
              newPassword="newPassword"
              confirmPassword="confirmPassword"
              sendEmail= "sendEmail"
              formControl="PasswordReset"
              newPasswordTitle="New Password"
              confirmPasswordTitle="Confirm Password"
              title={passTitle}
              subtitle="Use the form below to reset the user's password.
              Passwords must be at least 8 characters and contain 1 number."
              icon={<PasswordIcon />}
              submitForm={(field, data) => this.submitForm(field, data)}
              newUser={this.props.newUser}
            />
            <FormControlCard
              key={`mfa_enabled_${this.state.form.mfa_enabled || 'undefined'}`}
              form={this.state.form}
              field='mfa_enabled'
              formControl='ToggleInput'
              title='Enable Multi-Factor Authentication'
              submitForm={(field, data) => this.submitForm(field, data)}
              disabled={this.state.form.mfa_enforced === '1'}
              label='No / Yes'
              icon={<VerifiedUserIcon />}
              subtitle={this.state.form.mfa_enforced === '1' 
                ? 'Multi-Factor Authentication is enforced and cannot be disabled.'
                : 'When this setting is turned on, the user will be prompted to set up Multi-Factor Authentication next time they log in.'}
            />
            <FormControlCard
              form={this.state.form}
              field="resetMFAEnrollment"
              formControl="ResetMFAEnrollment"
              title="Reset MFA Enrollment"
              subtitle="Reset the user's Multi-Factor Authentication enrollment to allow them to set it up again."
              icon={<RestoreIcon />}
              resetMFAEnrollment={() => this.resetMFAEnrollment()}
            />
            <Footer
              onClick={(cancel) => this.submitFullForm(cancel)}
            />
          </StandardSettingsPage>
          </div>
        );
    }
}

const bindActions = (dispatch) => ({
    getCoreHttp: (reqData, storeKey) => dispatch(getCoreHttp(reqData, storeKey)),
    putCoreHttp: (reqData, storeKey) => dispatch(putCoreHttp(reqData, storeKey)),
    deleteCoreHttp: (reqData, storeKey) => dispatch(deleteCoreHttp(reqData, storeKey)),
});

const mapStateToProps = (state) => ({
  configurations: state.http.configurations,
  mfaSettings: state.loginManagement.mfaData,
  mfaStatus: state.loginManagement.mfaStatus,
  resetMfaStatus: state.http.reset_mfa,
});

export default connect(mapStateToProps, bindActions)(Settings);
